import { queryOptions, useQuery } from "@tanstack/react-query";
import { isApiError } from "../client";
import { api } from "../runtime";
import type { Me, OrganizationSummary } from "../types";
import { qk } from "./keys";

/**
 * The authoritative session: GET /v1/me (Better Auth session + backend authorization context).
 * Resolves to null when there is no session; any other error is thrown.
 */
export const meQueryOptions = () =>
  queryOptions({
    queryKey: qk.me(),
    queryFn: async (): Promise<Me | null> => {
      try {
        return await api.get<Me>("/v1/me");
      } catch (err) {
        if (isApiError(err) && err.isUnauthenticated) return null;
        throw err;
      }
    },
    staleTime: 60_000,
    retry: (count, err) => !(isApiError(err) && (err.isForbidden || err.isUnauthenticated)) && count < 2,
  });

export function useMe() {
  return useQuery(meQueryOptions());
}

/** Organizations the user belongs to (Better Auth organization plugin). */
export function useOrganizations(enabled = true) {
  return useQuery({
    queryKey: qk.organizations(),
    queryFn: () => api.get<OrganizationSummary[]>("/api/auth/organization/list"),
    enabled,
    staleTime: 5 * 60_000,
  });
}
